import * as React from 'react'

import { ACTIVITY_SUMMARY } from '../asset_constants'

const ActivitySummarySlide = ({ slideGroupClassName, }) => (
  <section className={`slide ${slideGroupClassName} activity-summary-slide`} key="activity-summary-slide">
    <h1>Use your dashboard to see student progress each step of the way</h1>
    <div className="flex-wrapper">
      <div className="img-wrapper">
        <img alt="Screenshot of the Activity Summary report." src={ACTIVITY_SUMMARY} />
      </div>
      <div className="text">
        <p>Use your <b>Activity Summary</b> dashboard to quickly see how your students performed on each activity.<br /><br />From there, you can dive into any particular activity to see exactly what the student wrote and how they responded to the feedback.</p>
      </div>
    </div>
  </section>
)

export default ActivitySummarySlide
